import React from 'react';
import { Routes, Route } from "react-router-dom";

// routes
import { publicRoutes } from "./allRoutes";

const Index = () => {
    return (
        <Routes>
            {publicRoutes.map((route, idx) => {
                const Layout = route.layout || React.Fragment;

                return (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <Layout>
                                {route.component}
                            </Layout>
                        }
                    />
                );
            })}
        </Routes>
    );
};

export default Index;
